import React from 'react';
import Main from '../../components/Main';
import { useNavigate } from 'react-router-dom';
import {Row, Col, Image, Button } from 'react-bootstrap';
import LongCard from '../../components/LongCard';
import register from '../../assets/images/register.png';
import '../../assets/styles/Global.css';

// Consultants Subpage of AboutUs Page

const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all images from the consultants folder into the images array

importAll(require.context('../../assets/images/aboutus_icons/consultants', false, /\.(png|jpe?g|svg)$/));

const consultants = [
  {
    title: "Associate your services with a quality brand",
    description: "Improve client visibility",
    details : `Become a IQosys member and position yourself as professional brand, enabling you to command higher daily rates due to the enhanced credibility and recognition that comes with our reputation.`,
    icon: images['consultants_1.png'],
  },
  {
    title: "Gain access to top tier clients and impactful projects",
    description: "Accelerate professional growth",
    details : `You'll gain access to top-tier clients across various industries, providing you with unparalleled opportunities to work on high-impact projects and further enhance your professional portfolio.`,
    icon: images['consultants_2.png'],
  },
  {
    title: "Increase your annual billing",
    description: "More staffing less downtime",
    details : `Participate in team projects rather than operating as an individual consultant means that you can engage in more complex and longer-term assignments, which translates to reduced downtime between projects and increased annual earnings.`,
    icon: images['consultants_3.png'],
  },
  {
    title: "Become an IQosys shareholder",
    description: "Participate in governance, dividends and create value",
    details : `As a member of the IQosys network, you’ll have the unique opportunity to earn equity for each project you deliver, to become a valued shareholder (see IQS Tokens).`,
    icon: images['consultants_4.png'],
  },
  {
    title: "Join the IQ based meritocracy",
    description: "Take ownership your career trajectory",
    details : `Our organization is built on a foundation of meritocracy, focused on client issues rather than internal operations, hierarchy and politics. With IQosys, your achievements and contributions are the sole determinants of your success, empowering you to operate with full autonomy and control over your career trajectory, while increasing your share ownership with each successfully completed project.`,
    icon: images['consultants_5.png'],
  },
];

const Consultant = () => {
  const navigate = useNavigate();
  const handleRegisterClick = () => {
    navigate('/myaccount/register'); // Redirect to the Register page
  };

  return (
    <div> 
      <Main componentList={[
          <h6 className='top_sentence'>Join our knowledge leaders and realize your full potential</h6>,
          <h7>Joining IQosys offers consultants numerous compelling advantages.</h7>,
        <Col className="mt-4">
          {consultants.map((consultant, index) => (
            <Row md={6} lg={1} key={index}>
              <LongCard className="h-100 shadow-sm" longcard={consultant}/>
            </Row>
          ))}
        </Col>,
        <h7>Join us today and become part of a dynamic team where excellence is rewarded, and your entrepreneurial spirit is celebrated.</h7>,
        <hr className="my-custom-hr"/>,
        <Button variant="light" 
          className="mt-auto btn-sm text-start align-self-start border-0"  
          onClick={handleRegisterClick}
          style={{ 
            backgroundColor: "white", 
            boxShadow: "none",
          }}
        >
          <div className="d-flex align-items-center" style={{marginBottom:"10px"}}>
            <Image src={register} width={32} height={32} alt="Register Icon" />
            <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>Apply to join</span>
          </div>
        </Button>
      ]} /> 
    </div>
  );
};

export default Consultant;